export default {
  'createbusinessprofile.createbusinessprofile': 'Создание бизнес- профиля',
};
